import { Box, Stack } from 'braid-design-system';
import React, { type FC, type RefObject } from 'react';

export const MainContentLayout: FC<{
  searchSection: JSX.Element | null;
  sortSection: JSX.Element | null;
  tableSection: JSX.Element;
  mainContentRef?: RefObject<HTMLDivElement>;
}> = ({ searchSection, sortSection, tableSection, mainContentRef }) => (
  <Box ref={mainContentRef} paddingTop="large">
    <Stack space="large">
      {searchSection}
      {sortSection}
      {tableSection}
    </Stack>
  </Box>
);
